// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';

import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// SECURITY IMPROVEMENT: Removed localStorage storage to use default cookie-based storage
// This mitigates XSS-based token theft by using httpOnly cookies when available
// The Supabase client will automatically use the most secure storage available
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  }
});
